// Define the ErrorType enum
export enum ErrorType {
    FAILURE = 0,
    UNEXPECTED = 1,
    VALIDATION = 2,
    CONFLICT = 3,
    NOTFOUND = 4,
    UNAUTHORIZED = 5,
    FORBIDDEN = 6
}
